import { render, staticRenderFns } from "./VerticalFilters.vue?vue&type=template&id=5aae82b4"
import script from "./VerticalFilters.vue?vue&type=script&lang=js"
export * from "./VerticalFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports